import { declareString } from "@1js/localization";

export const PluginTooltip = declareString("promptLibrary.PluginTooltip", {
  text: 'Once in chat, type "@" and an extension name to enable an extension in your prompt',
  comment:
    "Tooltip that's displayed to user when user hovers over the info button icon on a Copilot prompt card for a plugin prompt",
});
